
import Vue from "vue";
import registSuccess from "./regist-success.vue";
import { supplierSettledEmailValited } from "@/service/supplier-meta/api";
export default Vue.extend({
  name: "active-success",

  components: {
    registSuccess,
  },

  data() {
    return {
      loading: true,
      ready: false,
      isActived: false,
      step: 0,
      text1: "",
      text2: "",
      text3: "",
      text4: "",
    };
  },

  // http://172.16.13.65:8080/#/success/active-success?email=894249308%40qq.com&code=201810311049227YfNeZUKggG8r
  methods: {
    async emailValited() {
      this.loading = true;
      const { code } = this.$route.query;
      let res = await supplierSettledEmailValited(code + "" || "");
      const success = res.isSuccess;
      if (success) {
        this.step = 2;
        this.isActived = true;
        this.text1 = "已验证，提交审核成功";
        this.text2 = "我们会在3个工作日内完成审核。";
        this.text3 = "审核结果与账号信息将发送至您的邮箱";
        this.text4 = "邮箱验证完成，进入审核流程中";
      } else {
        this.step = 1;
        this.isActived = false;
        this.text1 = "验证失败！";
        this.text2 = res.errorInfo?.msg || "";
        this.text3 = "";
        this.text4 = "";
      }
      this.loading = false;
    },
  },

  mounted() {
    //this.$setTitle("收件箱");
    this.emailValited();
  },
});
